import { ImageWithDisplayName } from '@/common/components/ImageWithDisplayName'
import Modal from '@/common/components/Modal'
import { formatCurrency } from '@/common/utils/formatters'
import { ResumeItem } from '@/features/paymentAdvances/components/ResumeItem'
import { FuelIcon } from 'lucide-react'

interface PaymentAdvanceConfirmModalProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  message: string
  showEstablishment?: boolean
  establishmentName?: string
  establishmentLogoUrl?: string
  showResume?: boolean
  totalToBePaid?: string | number
  dateToBePaid?: string
  onConfirm: () => void
}

export const PaymentAdvanceConfirmModal = ({
  isOpen,
  setIsOpen,
  message,
  showEstablishment,
  establishmentName,
  establishmentLogoUrl,
  showResume,
  totalToBePaid,
  dateToBePaid,
  onConfirm,
}: PaymentAdvanceConfirmModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="w-80"
      body={
        <div className="space-y-4 text-white-800 p-1">
          <p className="text-2xl font-bold">{message}</p>

          {showEstablishment && (
            <ImageWithDisplayName
              placeholderIcon={FuelIcon}
              imageUrl={establishmentLogoUrl}
              displayName={establishmentName}
              imageClassName="size-6"
              iconClassName="size-4"
            />
          )}

          {showResume && (
            <>
              <ResumeItem label="Data para recebimento" value={dateToBePaid} />

              <ResumeItem
                label="Valor a receber antecipado"
                value={totalToBePaid ? formatCurrency(Number(totalToBePaid)) : ''}
              />
            </>
          )}
        </div>
      }
      footer="Finalizar"
      onConfirm={onConfirm}
    />
  )
}
